import { initializeApp } from "firebase/app";
import {
  initializeAppCheck,
  ReCaptchaEnterpriseProvider,
} from "firebase/app-check";
export default defineNuxtPlugin(() => {
  const { public: publicEnv } = useRuntimeConfig();
  const apiKey = publicEnv.FIREBASE_API_KEY ?? "";
  const recaptchaKey = publicEnv.FIREBASE_RECAPTCHA_KEY ?? "";

  if (apiKey !== "" && recaptchaKey !== "") {
    const firebaseConfig = {
      apiKey,
      projectId: publicEnv.FIREBASE_PROJECT_ID ?? "",
      appId: publicEnv.FIREBASE_APP_ID ?? "",
    };

    // Initialize Firebase
    const firebaseApp = initializeApp(firebaseConfig);

    // Initialize App Check
    initializeAppCheck(firebaseApp, {
      provider: new ReCaptchaEnterpriseProvider(recaptchaKey),
      isTokenAutoRefreshEnabled: true,
    });
  }
});
